import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 15000, // 15 seconds
});

// Request interceptor to attach token if present
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      // Attach bearer token for authenticated requests
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle global errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Read an opt-out header so certain requests (e.g., login) can bypass the global redirect
    const skipRedirect = error?.config?.headers?.["X-Skip-Auth-Redirect"] === "true";
    const status = error?.response?.status;

    if (!skipRedirect && status === 401) {
      // Invalid/expired token -> clear and hard redirect to /login
      localStorage.removeItem("token");
      window.location.href = "/login";
      // Note: we still reject so callers can optionally handle after redirect
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
